export const moreApps = "zfrnUe";
export const noApps = "hcA0c";
export const moreAppsAccessibleLabel = "DN7SDe";
export const addApps = "j$nFXb";
export const appsInMail = "KpnUWd";
export default {moreApps,noApps,moreAppsAccessibleLabel,addApps,appsInMail};